import React from 'react';
import Link from 'gatsby-link';

import HelmetSEO from '../components/seo';
import Components from '../components/components';
import LinkBack from '../components/link-back';
import { filterByTag, stripNode } from '../helpers/get-contents';

const InsightPage = ({ data }) => {
    const page = data.page.edges[0].node;
    const allInsights = stripNode(data.allInsights.edges);
    const relatedInsights = filterByTag(page.tag.tag, allInsights);

    let seo = {
        title: page.title,
        description: page.intro,
        image: page.image.sizes.src,
    };
    return (
        <div>
            <HelmetSEO {...seo} />

            <LinkBack
                parent={{
                    slug: 'insights',
                    pageName: 'Insights',
                }}
                className="on-insights"
            />
            <div className="section indented-contents gray-dividers">
                <div className="mt-60" />
                <Components
                    content={{
                        __typename: 'insight',
                        ...page,
                    }}
                />
                <Components
                    content={{
                        __typename: 'DatoCmsLinksToInsight',
                        title: 'Related insights',
                    }}
                    ignoreIndent={true}
                    insights={allInsights}
                />
            </div>
        </div>
    );
};

export default InsightPage;

export const InsightPageQuery = graphql`
    query InsightPageQusdasdfsdasdssdfdfry($slug: String!) {
        page: allDatoCmsInsightPage(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    slug
                    title
                    body
                    intro
                    location {
                        location
                    }
                    tag {
                        tag
                    }
                    caption
                    date(formatString: "MMMM DD, YYYY")
                    writer {
                        ...TraderFragment
                    }
                    image {
                        sizes(
                            maxWidth: 1100
                            imgixParams: { fm: "jpg", auto: "compress" }
                        ) {
                            base64
                            aspectRatio
                            src
                            srcSet
                            sizes
                        }
                    }
                }
            }
        }
        allInsights: allDatoCmsInsightPage(
            limit: 4
            sort: { fields: [date], order: DESC }
        ) {
            edges {
                node {
                    ...InsightCardFragment
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/templates/insight-template.js